import { gql } from '@apollo/client';

export const acceptTermsAndConditionsMutation = gql`
  mutation AcceptTermsAndConditionsMutation {
    acceptTerms(input: {})
      @rest(
        type: "AcceptTermsPayload"
        path: "profile/accept-terms"
        method: "PUT"
      ) {
      NoResponse
    }
  }
`;
